module.exports = __WEBPACK_EXTERNAL_MODULE_Y5LK__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"gofor","commonjs2":"gofor","amd":"gofor","root":"Gofor","var":"Gofor"}
// module id = Y5LK
// module chunks = 0